import * as React from 'react';

import Appraisal from '../../../component/common/Appraisal';
import { addAppraisal } from '../../../action/admin/Appraisal';
import Loder from '../../../component/common/Loader'
import { validateForm } from '../../../utils';
import CONSTANT from '../../../constant';

class AddAppraisal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showLoader: false
        }
    }

    public render() {
        const { showLoader } = this.state
        return (
            <React.Fragment>

                <section>
                    <div className="col-lg-12 main-container">
                        <div className="fluid-container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="col-lg-12 mt-4">
                                        <div className="row">
                                            <div className="col-lg-6 pl-0">
                                                <h5 className="heading-h1">Add Appraisal Cycle</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <Appraisal
                                        onSubmit={this.onSubmit}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    showLoader && <Loder />
                }
            </React.Fragment>

        )
    }


    onSubmit = (model: any) => {
        //  model.preventDefault();
        if (validateForm(this, model)) {
            this.setState({ showLoader: true })
            addAppraisal(model)
                .then((res: any) => {
                    console.log(res);
                    alert('Record Update Successfully')
                    this.setState({ showLoader: false })
                    this.props.history.push(CONSTANT.url.startAppraisal)
                })
                .catch((err: any) => {
                    alert(err)
                    this.setState({ showLoader: false })
                })
        }
    }

}

export default AddAppraisal;